import notifications from "@/api/notifications";

export default {
  state: {},
  mutations: {},
  actions: {
    async retrieveNotificationSettings(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        const response = await notifications.index(params);
        return response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateNotificationSettings(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        await notifications.update(params);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
